export default "__VITE_ASSET__DsYp3Wda__"